import { isEmpty, isNull } from 'lodash';
import { FixedNavItems, NavItems } from './nav-items';
import { Permissions } from '../../../../../shared/utils/access-control/enums/permissions';
import hasPermission from '../../../../../shared/utils/access-control/has-permission';
import { leadFinderViewOnly } from '../../../../../shared/utils/user-details';

type FilterNavItemsProps = {
  isAgency: number;
  client: Record<string, any>;
  isMultichannelActive: boolean;
  hasDomains: boolean;
  hasDedicatedIps: boolean;
  leadFinderVersion?: 'v1' | 'v2' | null;
};

export const filterNavItems = ({
  isAgency,
  client,
  isMultichannelActive,
  hasDomains,
  hasDedicatedIps,
  leadFinderVersion,
}: FilterNavItemsProps) => {
  const mappedNavItems = NavItems.map((item) => {
    if (item.key === 'billing') {
      return {
        ...item,
        text: hasPermission(Permissions.ACCOUNT_SUBSCRIPTION_READ)
          ? 'Billing & Subscription'
          : 'Plan details & Billing',
      };
    }
    // Update leads route based on version
    if (item.key === 'leads') {
      return {
        ...item,
        route: leadFinderVersion === 'v2' ? '/v2/leads' : '/leads',
      };
    }
    return item;
  });

  const tempFixedNavItems = FixedNavItems.filter((item) =>
    typeof item.permission === 'function'
      ? item.permission()
      : hasPermission(item.permission),
  );

  const tempBottomNavItems = [];

  let tempNavItems = mappedNavItems.filter((item) => {
    // Show 'leads' tab for agency-client users for specific shAccountId
    if (
      item.key === 'leads' &&
      !isNull(client) &&
      !isEmpty(client) &&
      leadFinderViewOnly()
    ) {
      return true;
    }

    if (
      typeof item.permission === 'function'
        ? item.permission()
        : hasPermission(item.permission)
    ) {
      // If the item is 'agency-client' and the user is not an agency,
      // then move it to fixed nav items and exclude from main nav
      if (item.key === 'agency-client' && !isAgency) {
        tempFixedNavItems.unshift(item);
        return false;
      }

      // Exclude the 'tasks' nav item if multichannel is not active
      if (item.key === 'tasks' && !isMultichannelActive) {
        return false;
      }

      // Move 'settings' nav item to bottom if user is not an agency user
      if (item.key === 'setting' && (isNull(client) || isEmpty(client))) {
        tempBottomNavItems.push(item);
        return false;
      }

      return true;
    }

    return false;
  });

  tempNavItems = tempNavItems.map((item) => {
    if (item?.subNavItems?.length) {
      const tempItems = { ...item };

      const tempSubNavItems = item.subNavItems.filter((obj) => {
        if (item.key === 'email-accounts') {
          if (obj.key === 'domains' && !hasDomains) {
            return false;
          }
          if (obj.key === 'inframail-ips' && !hasDedicatedIps) {
            return false;
          }
        }
        return true;
      });

      tempItems.subNavItems = tempSubNavItems;

      return tempItems;
    }

    return item;
  });

  return {
    filteredNavItems: tempNavItems,
    filteredFixedNavItems: tempFixedNavItems,
    filteredBottomNavItems: tempBottomNavItems,
  };
};
